import React from 'react';
import { Typography, makeStyles, Grid } from '@material-ui/core';

const useStyles = makeStyles(() => ({

    title: {
        fontSize: '0.9em',
        color: '#000',
    },

    message: {
        fontSize: '0.9em',
        color: '#000',
    },

}));

interface GuideProps {
    title: string;
    message: string;
}

export default function Guide(props: GuideProps) {

    const classes = useStyles();

    return (
        <div>
            <Grid>
                <Grid item sm = { 12 }>
                    <Typography className={classes.title}>
                        {props.title}
                    </Typography>
                </Grid>

                <Grid item sm = { 12 }>
                    <Typography className={classes.message}>
                        <React.Fragment>
                            {props.message}
                        </React.Fragment>
                    </Typography>
                </Grid>
            </Grid>
        </div>
    );
}